import { BLOG_POSTS } from './blogPosts';

export function slugifyBlogCategory(category) {
    return String(category || '')
        .trim()
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export function getBlogCategoryDescription(category, count) {
    const normalizedCategory = String(category || 'blog').toLowerCase();
    const postLabel = count === 1 ? 'post' : 'posts';

    return `Read ${count} Luckynote ${postLabel} about ${normalizedCategory}, note-taking, saving ideas, and building a calmer personal knowledge system.`;
}

export function getBlogCategoryEntries() {
    const categoryMap = new Map();

    Object.entries(BLOG_POSTS).forEach(([slug, post]) => {
        if (!post.category) return;

        const categorySlug = slugifyBlogCategory(post.category);
        const existing = categoryMap.get(categorySlug) || {
            name: post.category,
            slug: categorySlug,
            posts: []
        };

        existing.posts.push({
            ...post,
            slug
        });

        categoryMap.set(categorySlug, existing);
    });

    return Array.from(categoryMap.values()).map((category) => ({
        ...category,
        description: getBlogCategoryDescription(category.name, category.posts.length),
        posts: category.posts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    }));
}

export function getBlogCategoryBySlug(categorySlug) {
    return getBlogCategoryEntries().find((category) => category.slug === categorySlug) || null;
}
